export const baseShadow = {
  /** 가장 약한 그림자 - 미묘한 입체감 */
  alternative: "0 0 2px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.08)",

  /** 기본 그림자 - 일반적인 카드, 컨테이너 */
  normal: "0 0 4px rgba(0, 0, 0, 0.12), 0 3px 10px rgba(0, 0, 0, 0.10)",

  /** 강한 그림자 - 모달, 드롭다운, 강조 요소 */
  accent: "0 0 8px rgba(0, 0, 0, 0.16), 0 3px 10px rgba(0, 0, 0, 0.10)",
} as const;

export type ShadowToken = keyof typeof baseShadow;
export type ShadowValue = typeof baseShadow[ShadowToken];
